
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/legislative-regulatory-activity/proposed-regulation-bulletin",
      function () {
        return require("private-next-pages/compliance/legislative-regulatory-activity/proposed-regulation-bulletin/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/legislative-regulatory-activity/proposed-regulation-bulletin"])
      });
    }
  